// extracted by css-extract-rspack-plugin
export default {"mainChart":"Skeleton-module__mainChart__x6Poifq","title":"Skeleton-module__title__Eg6Nuxl","subtitle":"Skeleton-module__subtitle__x0TKlrL"};